import { render, staticRenderFns } from "./SaveRoleResourceButton.vue?vue&type=template&id=888678d4&scoped=true&"
import script from "./SaveRoleResourceButton.vue?vue&type=script&lang=js&"
export * from "./SaveRoleResourceButton.vue?vue&type=script&lang=js&"
import style0 from "./SaveRoleResourceButton.vue?vue&type=style&index=0&id=888678d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888678d4",
  null
  
)

export default component.exports